import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import { useParams } from 'react-router-dom';
import './stylea.css';
//import './styleCounter.css';
import L from 'leaflet';
import Header from './Header';
import Footer from './Footer';
import ErrorTechnique from './ErrorTechnique';
import ErrorTech from './ErrorTech';
import { getloc } from '../api/webGeolocApi';
import geohash from 'ngeohash';
import { animatedMarker } from "./AnimatedMarker";
import Bulle_Camion from "./Bulle_Camion.png";
import Bulle_Maison from "./Bulle_Maison.png";



function Markers({ marker }) {

   function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var R = 6371 / 2; // Radius of the earth in km
      var dLat = deg2rad(lat2 - lat1);  // deg2rad below
      var dLon = deg2rad(lon2 - lon1);
      var a =
         Math.sin(dLat / 2) * Math.sin(dLat / 2) +
         Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
         Math.sin(dLon / 2) * Math.sin(dLon / 2)
         ;
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d;
   }

   function deg2rad(deg) {
      return deg * (Math.PI / 180)
   }



   const icon = new L.Icon({
      className: 'blinking', iconUrl: Bulle_Maison,
      iconSize: [50, 37],
   });

   var carIcon = L.icon({
      iconSize: [55, 40],
      iconAnchor: [35, 33],
      iconUrl: Bulle_Camion,
      className: 'blinking',
   });

   const map = useMap();
   const geo = geohash.decode_bbox(marker.hash);
   const geoLatLong = geohash.decode(marker.hash);

   const radiusCirle = getDistanceFromLatLonInKm(geo[0], geo[1], geo[2], geo[3]);
   const circle = L.circle([geoLatLong.latitude, geoLatLong.longitude], radiusCirle * 1000, { color: "#1DA1F2", weight: 2 });

   //const mark = L.marker([marker.RAlocation.latitude, marker.RAlocation.longitude], { icon: icon });

   if (marker.RAlocation.length !== 0) {

      const mark = L.marker([marker.RAlocation.latitude, marker.RAlocation.longitude], { icon: icon });
      if (marker.status === "work_in_progress") {
         circle.bindPopup(L.popup({ maxWidth: 500 }).setContent("Votre technicien termine une autre intervention")).addTo(map);
         mark.addTo(map);


         circle.addTo(map);
         mark.addTo(map);
         const bounds = [
            [[geoLatLong.latitude, geoLatLong.longitude]],
            [[marker.RAlocation.latitude, marker.RAlocation.longitude]]
         ]
         map.fitBounds(bounds, { maxZoom: 14 });

      }
      else if (marker.status === "ongoing") {

         circle.bindPopup(L.popup({ maxWidth: 500 }).setContent("Votre technicien est en route!")).openPopup().addTo(map);
         mark.addTo(map);
         const insideOutsideCircle = circle.getBounds().contains(mark.getLatLng());
         if (!insideOutsideCircle) {

            circle.remove();
            // L.marker([geoLatLong.latitude, geoLatLong.longitude], { icon : greenIcon}).addTo(map);
            const polyline = L.polyline([[geoLatLong.latitude, geoLatLong.longitude],
            [marker.RAlocation.latitude, marker.RAlocation.longitude]],
               {
                  color: '#1DA1F2', weight: 6
               }).addTo(map);
            const realRouteLine = L.polyline([], {
               weight: 6,
               color: '#FF9900'
            });
            realRouteLine.addTo(map);
            L.polylineDecorator(polyline,
               {
                  patterns: [
                     {
                        repeat: 50,
                        symbol: L.Symbol.arrowHead({
                           pixelSize: 5,
                           headAngle: 75,
                           polygon: false,
                           pathOptions: {
                              stroke: true,
                              weight: 2,
                              color: "#FFFFFF",
                           },
                        }),
                     },
                  ],
               }).addTo(map);
            const arr = [];

            /* animatedMarker(polyline.getLatLngs(), {
                icon: carIcon,
                isRotate: true,
                playCall: realRouteLine.setLatLngs(arr),
             }).addTo(map);*/
            L.marker([geoLatLong.latitude, geoLatLong.longitude], { icon: carIcon }).addTo(map);
            //const markerGauche= L.marker([geoLatLong.latitude, geoLatLong.longitude], { icon: carIconGauche }).addTo(map);

            const images = document.getElementsByTagName('img');
            const imagesWithSrc = [];
            var imageHome;
            // var serachImage="data:image/png;base64,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";
            var serachImage = "data:image/png;base64,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";
            var srcHome = "data:image/png;base64,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";
            for (let i = 0; i < images.length; i++) {
               const src = images[i].getAttribute('src');
               if (src && src.includes(serachImage)) {

                  imagesWithSrc.push(images[i]);
               }
               if (src && src.includes(srcHome)) {
                  imageHome = images[i];
               }
            }
            const indexToRemove = 1;
            const secondImage = imagesWithSrc[1];
            if (secondImage) {
               secondImage.remove();
            }
            const bounds = [
               [[geoLatLong.latitude, geoLatLong.longitude]],
               [[marker.RAlocation.latitude, marker.RAlocation.longitude]]
            ]
            map.fitBounds(bounds, { maxZoom: 14 });

         }

      }
   } else {
      if (marker.status === "work_in_progress") {

         circle.bindPopup(L.popup({ maxWidth: 500 }).setContent("Votre technicien termine une autre intervention")).openPopup().addTo(map);
         map.fitBounds(circle.getBounds());
      } else if (marker.status === "ongoing") {

         const marker = L.marker([geoLatLong.latitude, geoLatLong.longitude], { icon: carIcon }).addTo(map);
         const markerBounds = L.latLngBounds([marker.getLatLng()]);

         map.fitBounds(markerBounds, { maxZoom: 14 });
      }

   }
   return null;
}

function MapClient({ mark }) {

   const [msg, setMsg] = useState();
   const zoom = 17;
   const geo = geohash.decode_bbox(mark.hash);
   const center = [geo[0], geo[1]]
   useEffect(() => {


      function testPosition() {
         if (mark.status === "work_in_progress") {

            const work_in_progress = "La tournée de votre technicien est en cours";
            setMsg("La tournée de votre technicien est en cours");

         } else if (mark.status === "ongoing") {
            const ongoing = "Votre technicien est en route!";
            setMsg(ongoing);
         }


      }

      testPosition()
   }, [msg])



   return (
      <div >

         <MapContainer center={center} zoom={zoom} style={{ height: "90vh", opacity: 'O,33' }}>
            <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
               url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Markers marker={mark} />
            <div style={{ position: "absolute", zIndex: "2000", left: "50%", transform: "translate(-50%, -50%)", bottom: "50px", padding: "5px", border: "1px solid #1DA1F2", backgroundColor: "white" }} > {msg}</div>
         </MapContainer >

      </div>);
};

const TestClient = () => {
   const { folder } = useParams();

   const [par, setpar] = useState([]);
   const [ind, setind] = useState(false);

   useEffect(() => {
      // Named function "get"
      async function getposition(folder) {
         try {
            const parameters = await getloc(folder);
            if (typeof (parameters) !== 'string') {
               setind(true);
            }

            setpar(parameters)


         } catch (err) {
            console.log('Error occured ');
         }
      }
      // Call named function
      getposition(folder);

   }, []);

   return (
      !ind ? <>
         <ErrorTech />
      </> : <>
         <Header />
         <MapClient mark={par} />
         <Footer />
      </>
   )
   /*if (ind) {
      return (
         <>
            <Header />
            <MapClient mark={par} />
            <Footer />
         </>
      );
   } else {
      return (
         );
   } */
};
export default TestClient;




const CountdownTimer = () => {
   const [countdown, setCountdown] = useState(300);

   useEffect(() => {
      const intervalId = setInterval(() => {
         // Décrémenter le décompte de 1 chaque seconde
         setCountdown(prevCountdown => prevCountdown - 1);
      }, 1000);

      // Nettoyer l'intervalle lorsque le composant est démonté
      return () => clearInterval(intervalId);
   }, []);

   useEffect(() => {
      // Rafraîchir automatiquement toutes les 300 secondes
      const refreshIntervalId = setInterval(() => {
         // Mettre à jour votre logique de rafraîchissement ici
         window.location.reload();
      }, 300000); // 300 secondes en millisecondes

      // Nettoyer l'intervalle de rafraîchissement lorsque le composant est démonté
      return () => clearInterval(refreshIntervalId);
   }, []);

   // Convertir le décompte en minutes et secondes
   const minutes = Math.floor(countdown / 60);
   const seconds = countdown % 60;

   return (
      <div style={{ position: "absolute", zIndex: "2000", left: "50%", transform: "translate(-50%, -50%)", bottom: "50px", padding: "5px", border: "1px solid #1DA1F2", backgroundColor: "white" }} > 
         {/*<div id="wrapper"  >

            <div id="minuteur">
               <div class="box">
                  <div id="m">{minutes}</div>
                  <div class="unite">minutes</div>
               </div>
               <div class="box">
                <div id="s">{seconds}</div>
                <div class="unite">seconds</div>
            </div>
            </div>

       </div>*/}
         <TestClient />
      </div>
   );
};

//export default CountdownTimer;







